import { connect } from 'react-redux';
import buildFAQlist from '../../../features/legend/shared/FAQSectionUtils';
import StudentSummary from '../../../features/studentSummary/shared/StudentSummary';
import { getStudentSummaryNavTabs } from '../../../features/studentSummary/shared/studentSummaryNavigation/studentSummaryNavTabs';
import { getSelectedTabId } from '../../../utils/shared/filterUtils';
import {
    selectStudent,
    clearStudentSummaryData,
} from '../../../api/studentSummary/shared/studentSummaryActions';
import {
    selectDemoStudent,
    fetchStudentDemoEnrollmentInfo,
} from '../../../api/demoMode/reading/demoModeActions';
import fetchStudentEnrollmentInfo from '../../../api/studentSummary/reading/studentSummaryActions';
import { selectors } from '../../../root/reading/root';
import LinkWrapper from '../../../features/navigation/LinkWrapper';
import { SS_URL } from '../../../constants/reading/ApiConstants';
import { LICENSE } from '../../../constants/reading/CommonConstants';
import getAvailibleQuestions from '../../../utils/reading/FAQSectionUtils';
import { PROGRESS_ICONS_GROUP, TRC_ICONS } from '../../../features/legend/shared/legendConstants';
import { getStudentSummaryLegendSections } from '../../../features/legend/shared/legendUtils';
import isStandaloneExpress from '../../../utils/reading/expressUtils';

const { TRC } = LICENSE;

const mapStateToProps = state => {
    const location = selectors.getLocation(state);
    const lastLocation = selectors.getLastLocation(state);
    const licensingInfo = selectors.getLicensingInfo(state);
    const isTRCSummaryAvailable = licensingInfo.includes(TRC);
    const isProgressSummaryAvailable = !isStandaloneExpress(licensingInfo);
    const navTabs = getStudentSummaryNavTabs(
        location,
        SS_URL,
        isTRCSummaryAvailable,
        isProgressSummaryAvailable,
    );
    const selectedTabId = getSelectedTabId(navTabs, location.pathname);
    return {
        licensingInfo,
        location,
        lastLocation,
        selectedTabId,
        navTabs,
        demoClass: selectors.getDemoClass(state),
        isDemoModeOn: selectors.getIsDemoModeOn(state),
        student: selectors.getStudentById(state, selectors.getSelectedStudentId(state)),
        chosenDistrictUid: selectors.getDistrictId(state),
        legendSections: getStudentSummaryLegendSections({
            selectedTabId,
            isTRCSummaryAvailable,
            licensingInfo,
            FAQList: buildFAQlist(
                location,
                selectors.getLicensingInfo(state),
                getAvailibleQuestions,
            ),
            trcIcons: TRC_ICONS,
            progressIcons: PROGRESS_ICONS_GROUP,
            trc: TRC,
        }),
        LinkWrapper,
    };
};

const mapDispatchToProps = dispatch => ({
    selectStudent: isDemoModeOn =>
        isDemoModeOn
            ? studentId => dispatch(selectStudent(studentId))
            : studentId => dispatch(selectDemoStudent(studentId)),
    fetchStudentEnrollmentInfo: (isDemoModeOn, demoClass) =>
        isDemoModeOn
            ? studentId => dispatch(fetchStudentDemoEnrollmentInfo(studentId, demoClass))
            : studentId => dispatch(fetchStudentEnrollmentInfo(studentId)),
    clearStudentSummaryData: () => dispatch(clearStudentSummaryData()),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { isDemoModeOn, demoClass } = stateProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        fetchStudentEnrollmentInfo: dispatchProps.fetchStudentEnrollmentInfo(
            isDemoModeOn,
            demoClass,
        ),
        selectStudent: dispatchProps.selectStudent(isDemoModeOn),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(StudentSummary);
